import type { TextBlockModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import FontSizeModifierComponent from "./FontSizeModifier";
import FontStyleControls from "./FontStyleControls";
import FontWeightModifierComponent from "./FontWeightModifier";
import LineHeightModifierComponent from "./LineHeightModifier";
import TextSpacingModifierComponent from "./TextSpacingModifier";

interface StyleModifierProps {
  onChange: (modifiers: TextBlockModifierValue[]) => void;
}

const StyleModifier: React.FC<StyleModifierProps> = ({ onChange }) => {
  const [savedStyleMode, setSavedStyleMode] = React.useState(false);

  return (
    <div className="space-y-4">
      <div className="flex w-full flex-col gap-2">
        <FontStyleControls
          onChange={onChange}
          savedStyleMode={savedStyleMode}
          setSavedStyleMode={setSavedStyleMode}
        />
        {!savedStyleMode && (
          <div className="grid grid-cols-2 gap-2">
            <FontWeightModifierComponent onChange={onChange} />
            <FontSizeModifierComponent onChange={onChange} />
            <div className="flex flex-col gap-1">
              <span className="text-xs font-medium text-muted">Line</span>
              <LineHeightModifierComponent onChange={onChange} />
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-xs font-medium text-muted">Spacing</span>
              <TextSpacingModifierComponent onChange={onChange} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StyleModifier;
